(function () {
  var style = document.createElement('style');
  style.textContent = [
    '#ag-toast {',
    '  position: fixed;',
    '  bottom: 2rem;',
    '  left: 50%;',
    '  transform: translateX(-50%) translateY(0.5rem);',
    '  background: #0e3e29;',
    '  color: #fff;',
    '  padding: 0.875rem 1.5rem;',
    '  border-radius: 10px;',
    '  font-family: var(--ag-font-ui, system-ui, sans-serif);',
    '  font-size: 0.9375rem;',
    '  font-weight: 500;',
    '  letter-spacing: 0.01em;',
    '  white-space: nowrap;',
    '  box-shadow: 0 8px 24px rgba(0,0,0,0.22);',
    '  opacity: 0;',
    '  transition: opacity 0.22s ease, transform 0.22s ease;',
    '  pointer-events: none;',
    '  z-index: 9999;',
    '}',
    '#ag-toast.is-visible {',
    '  opacity: 1;',
    '  transform: translateX(-50%) translateY(0);',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  var toast = document.createElement('div');
  toast.id = 'ag-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  document.body.appendChild(toast);

  var timer = null;

  document.addEventListener('ag:cart:added', function (e) {
    var title = e.detail && e.detail.title ? e.detail.title : 'Item';
    toast.textContent = title + ' added to cart \u2713';

    clearTimeout(timer);
    toast.classList.add('is-visible');

    timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3000);
  });
})();
